import { useState } from "react";

import PropTypes from "prop-types";

import ButtonNew from "components/atoms/ButtonNew/index";
import Img from "components/atoms/Img";
import Title from "components/atoms/Title";
import Toast from "components/atoms/Toast";
import EbookModal from "components/molecules/EbookModal";
import FormDownloadModal from "components/templates/common/post/FormDownloadModal";
import PostModal from "components/templates/common/post/PostModal";

import styles from "./Index.module.scss";

const GuideGrid = ({ datas, ...props }) => {
  const ItemCard = ({ data, ...props }) => {
    const [showFormDownload, setShowFormDownload] = useState(false);
    const [typeFormDownload, setTypeFormDownload] = useState("sg_ecommerce");
    const [open, setOpen] = useState(false);

    return (
      <div className={props?.className}>
        <div className={`group ${styles.guideGrid} `}>
          <Img
            className="object-fill"
            wrapper={{
              className: `group-hover:-translate-y-14 group-hover:scale-[0.71] ${styles.imgClass}`,
            }}
            {...data?.image}
          />
          <Title
            text={data?.title}
            as="h3"
            className={`min-h-[56px] px-4 text-left text-lg font-semibold leading-7 text-bbc-brand-700 transition-all duration-500 ease-out line-clamp-2 group-hover:-translate-y-[120px] lg:text-center ${
              data?.description ? "mb-10" : ""
            }`}
          />

          <div className="absolute inset-x-0 bottom-0 px-4 pt-0 pb-4 text-left opacity-0 transition-all duration-500 ease-out group-hover:opacity-100 lg:text-center">
            {data?.description && (
              <p
                className="mb-6 text-black"
                dangerouslySetInnerHTML={{ __html: data.description }}
              />
            )}
            <div className="text-center">
              {data?.typeFormDownload ? (
                <ButtonNew
                  btnDisplay={"inline-flex justify-center items-center"}
                  othersClass="relative uppercase"
                  as="button"
                  onClick={() => {
                    setShowFormDownload(true);
                    setTypeFormDownload(data?.typeFormDownload);
                  }}
                >
                  Download now
                </ButtonNew>
              ) : (
                <ButtonNew
                  btnDisplay={"inline-flex justify-center items-center"}
                  othersClass="relative uppercase"
                  as="a"
                  href={data.url}
                >
                  Download now
                </ButtonNew>
              )}
            </div>
          </div>
        </div>
        {data?.post_modal && (
          <Toast>
            <PostModal
              show={open}
              onHide={() => setOpen(false)}
              ebookdata={data.post_modal}
            />
          </Toast>
        )}
        {data?.ebook_modal && (
          <Toast>
            <EbookModal
              show={open}
              onHide={() => setOpen(false)}
              apiLink={data?.ebook_modal.apiLink}
              contactFromId={data?.ebook_modal.contactFromId}
              imgLeft={data?.ebook_modal.imgLeftSrc}
              triggerName={data?.ebook_modal.triggerName}
            />
          </Toast>
        )}
        <FormDownloadModal
          show={showFormDownload}
          onHide={() => setShowFormDownload(false)}
          typeFormDownload={typeFormDownload}
        />
      </div>
    );
  };

  return (
    <div className="flex space-x-6 overflow-x-auto lg:row lg:space-x-0">
      {datas &&
        datas.length > 0 &&
        datas.map((item, itemIdx) => (
          <ItemCard
            key={itemIdx}
            data={item}
            className={`${props.className} mb-6 lg:mb-10`}
          />
        ))}
    </div>
  );
};

const BusinessGuides = ({
  title,
  description,
  dataList,
  wrapperStyles,
  contentStyles,
}) => {
  return (
    <>
      <div className="container text-center">
        <Title
          text={title}
          className="title-h2 mb-5 text-bbc-30px text-bbc-brand-800 lg:mb-6"
        />
        <p className="mb-10">{description}</p>

        <div className={`mx-auto ${wrapperStyles}`}>
          <GuideGrid datas={dataList} className={contentStyles} />
        </div>
      </div>
    </>
  );
};

export default BusinessGuides;

BusinessGuides.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  dataList: PropTypes.array,
  wrapperStyles: PropTypes.string,
  contentStyles: PropTypes.string,
};

BusinessGuides.defaultProps = {
  title: "",
  description: "",
  dataList: [],
  wrapperStyles: "",
  contentStyles: "",
};
